module.exports = __webpack_public_path__ + "img/drawer_box2.86bf3363.png";